import { Input, Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[goBack]',
})
export class GoBackDirective {
  @Input() goBack: string;

  constructor(
    private router: Router
  ) { }

  @HostListener('click')
  onClick() {
    if (this.goBack && window.history.length <= 2) {
      this.router.navigate([this.goBack]);
    } else {
      window.history.back();
    }
  }
}
